<!--电子围栏 -->
<template>
  <div class="electricFence">
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;">
          <el-link type="primary" @click="goToDetailgPage">
            ({{ basicinfo.deviceSn }})
          </el-link>
        </span>
        <span class="fontStyle2" />
        <span class="fontStyle1">
          {{ basicinfo.mechBrand }} / {{ basicinfo.mechModel }} / {{ basicinfo.batteryBrand }} / {{ basicinfo.batteryCapacity }} Ah / {{ basicinfo.batteryVoltage }} V
        </span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}: V{{ basicinfo.fwVersion }}</span><!--固件-->
      </div>
    </el-row>

    <div class="map_box energyMapBox" :style="'zIndex:8'">
      <div id="location" v-loading="loading" class="amap" />
      <div class="contentInfoBox">
        <div class="flex_bet geofencingSwitch">
          <span class="name fontColor">{{ $t('location.geofencing') }}</span>
          <el-switch v-model="isOpenFence" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" :disabled="role=='commonUser'||role=='guest'" @change="changeOpenFence" />
        </div>
        <div v-show="isOpenFence" class="location_form_box" :class="{'edit':editFenceBl,'view':!editFenceBl}">
          <p class="flex_bet item_box geofencSetP">
            <span>{{ $t('location.FenceSet') }}</span>
            <span v-if="!editFenceBl&&role!='commonUser'&&role!='guest'" class="deviceTheme click" @click="editorFence">{{ $t('adminView.Edit') }}</span>
            <span v-if="editFenceBl&&role!='commonUser'&&role!='guest'" v-preventReClick class="deviceTheme click" @click="submit">{{ $t('sideBar.docSave') }}</span>
          </p>
          <p class="flex_bet itemBack item_box">{{ $t('location.radius') }}
            <span v-if="editFenceBl" class="valueP">{{ editRadius }}M</span>
            <span v-else class="valueP">{{ radius }}M</span>
          </p>
          <p class="tips">{{ $t('socDetailPage.Note') }}{{ $t('location.dragCenterToMoveAround') }}</p>
          <p class="flex_bet itemBack item_box">
            <span>{{ $t('location.coordinate') }}</span>
            <span v-if="editFenceBl" class="valueP">{{ editLng.toFixed(4) }} / {{ editLat.toFixed(4) }}</span>
            <span v-else class="valueP">{{ lng.toFixed(4) }} / {{ lat.toFixed(4) }}</span>
          </p>
          <div class="flex_bet itemBack item_box">
            <span>{{ $t('location.validTime') }}</span>
            <el-date-picker v-model="dataTime" size="mini" type="daterange" :clearable="false" :default-time="['00:00:00', '23:59:59']" range-separator="~" :disabled="!editFenceBl" :start-placeholder="$t('deviceDetail.startDate')" :end-placeholder="$t('deviceDetail.endDate')" value-format="timestamp" />
          </div>
          <div class="flex_bet itemBack item_box ">
            <span> {{ $t('warningPage.Remark') }}</span>
            <el-input v-model="textarea" type="textarea" :rows="2" :disabled="!editFenceBl" :placeholder="$t('warningSet.Pleaseenter')" />
          </div>
        </div>
        <div v-if="warningTableData.length" class="location_form_box warnWarp" :class="{'edit':editFenceBl,'view':!editFenceBl}">
          <p class="flex_bet warnP geofencSetP">
            <span>{{ $t('adminView.warnInfo') }}</span>
          </p>
          <div class="warnBox">
            <div v-for="(item,index) in warningTableData" :key="index" class="warnItem">
              <p class="item_box">
                <img :src="imgSrc" class="warnMsgImg">
                <span class="">{{ $t('location.warning') }}</span>
              </p>
              <p class="item_box">
                <span v-if="!item.delFlag" class="danger status">{{ $t('warningPage.Unsolved') }}</span>
                <span v-if="item.delFlag==1" class="info status">{{ $t('warningPage.Solevd') }}</span>
                <span>{{ item.createTimeZh }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getGNSSLastByMcuID, getGnssGeofenceByMcuId, findDeviceInfo, addGnssGeofence, updateGnssGeofenceStatus, listWarningPushMsg } from '@/api/locationManagement'
import { tianMapLngLat, wgsToGcj } from '@/utils/transformLatLng'
import { getDateAndHour } from '@/utils/updateTime.js'
import { loadTiandiJs, loadGoogleJS } from '@/components/tianMap/asyncLoadJs'

export default {
  data() {
    return {
      basicinfo: {},
      map: null,
      dataTime: [],
      textarea: '',
      centerLo: null, // 设备位置经度
      centerLa: null, // 设备位置纬度
      isOpenFence: false, // 开启围栏
      editor: null,
      circle: null,
      radius: 2000, // 围栏半径
      lng: 114.068842, // 围栏中心经度
      lat: 22.655542, // 围栏中心纬度
      positionMarker: null,
      greenIcon: null,
      zoom: 5,
      bigZoom: 10,
      editFenceBl: false, // 编辑围栏
      editLng: 114.068842, // 编辑围栏时的定位
      editLat: 22.655542, // 编辑围栏时的定位
      editRadius: 2000, // 编辑围栏时的半径
      loading: false,
      warningTableData: [],
      interval: null,
      countNum: 0,
      currentMap: 'tianMap',
      loadGoogleMapJS: false,
      imgSrc: require('@/assets/icon/warn_3.png')
    }
  },
  computed: {
    ...mapState(['role']),
    mcuId() {
      return this.$route.query.mcuId
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  created() {
    // 判断是否加载过
    if (this.$store.state.map == 'gdMap') return
    if (!this.loadGoogleMapJS) {
      this.loading = true
      loadGoogleJS().then(() => {
        console.log('谷歌地图js加载好了')
        this.loadGoogleMapJS = true
        this.loading = false
      })
    }
  },
  mounted() {
    this.loading = true
    setTimeout(() => {
      this.initMap()
    }, 2000)
    this.queryList()
    this.listWarningPushMsg()
  },
  methods: {
    initMap() {
      if (this.map) return
      if (this.$store.state.map != 'gdMap') {
        console.log('loading-google-map')
        if (this.interval)clearInterval(this.interval)
        this.interval = setInterval(() => {
          console.log('this.countNum', this.countNum, this.interval)
          this.countNum++
          if (this.loadGoogleMapJS) {
            this.countNum = 0
            clearInterval(this.interval)
            this.initGoogleMap()
          } else if (this.countNum >= 10) {
            if (this.$route.path != '/locationMagt/electricFence') { // 避免弹窗关闭后定时器还在运行，弹出提示语，并且加载天地图，却又因为dom不存在而导致渲染出问题
              this.countNum = 0
              clearInterval(this.interval)
              return
            }
            this.$message(this.$t('location.switched_map'))
            this.currentMap = 'tianMap'
            clearInterval(this.interval)
            this.loadTiandi()
          }
        }, 1000)
      } else {
        this.loadTiandi()
      }
    },
    loadTiandi() {
      this.loading = true
      loadTiandiJs().then(res => {
        console.log('天地图加载成功')
        this.initTianMap()
        this.tianMapLoadFinished = true
      }).catch(() => {
        this.loading = false
        console.log('天地图加载失败')
        this.tianMapLoadFinished = false
      })
    },
    initTianMap() { // 初始化地图
      this.map = new T.Map('location')
      // 设置显示地图的中心点和级别
      this.map.centerAndZoom(tianMapLngLat(114.068842, 22.655542), this.zoom + 5)
      this.greenIcon = new T.Icon({
        iconUrl: require('@/assets/icon/green.png'), // "http://api.tianditu.gov.cn/img/map/markerA.png",
        iconSize: new T.Point(30, 30),
        iconAnchor: new T.Point(10, 25)
      })
      this.loading = false
      this._getGNSSLastByMcuID()
    },
    initGoogleMap() {
      this.currentMap = 'google'
      this.map = ''
      this.map = new google.maps.Map(document.getElementById('location'), {
        center: { lat: 22.655542, lng: 114.068842 },
        zoom: 6,
        minZoom: 3,
        mapId: '8d2035dc3e61cc22',
        disableDefaultUI: true
      })
      this.loading = false
      this._getGNSSLastByMcuID()
    },
    _getGNSSLastByMcuID() { // 高精度定位
      // this.loading = true
      getGNSSLastByMcuID({ mcuId: this.mcuId }).then(res => {
        // this.loading = false
        console.log(res)
        if (res.resultCode == 1001) {
          // 获取定位后，描点，再获取围栏，画圈
          if (res.resultModel) {
            this.centerLo = res.resultModel.lon
            this.centerLa = res.resultModel.lat
            // 初始化围栏中心
            this.lng = this.editLng = res.resultModel.lon
            this.lat = this.editLat = res.resultModel.lat
            this.setPosition()
          } else {
            this.$message({
              showClose: true,
              message: this.$t('yhubReport.Nodata')
            })
          }
          this.queryFence()
        }
      })
    },
    setPosition(zoom) { // 定位描点
      // console.log('setPosition:this.centerLo,this.centerLa',this.centerLo,this.centerLa)
      if (this.currentMap == 'tianMap') {
        if (!this.centerLo && this.centerLo != 0) {
          this.map.centerAndZoom(tianMapLngLat(114.068842, 22.655542), zoom || this.zoom + 5)
          return
        }
        this.positionMarker = new T.Marker(tianMapLngLat(this.centerLo, this.centerLa), { icon: this.greenIcon })
        this.map.centerAndZoom(tianMapLngLat(this.centerLo, this.centerLa), zoom || this.zoom + 5)
        this.map.addOverLay(this.positionMarker)
      } else {
        const uluru = { lat: this.centerLa, lng: this.centerLo }
        this.map.setCenter(new google.maps.LatLng(this.centerLa, this.centerLo))
        this.map.setZoom(10)
        this.positionMarker = new google.maps.Marker({
          position: uluru,
          map: this.map,
          icon: {
            url: require('@/assets/icon/green.png'),
            scaledSize: new google.maps.Size(30, 30)
          }
        })
      }
    },
    changeOpenFence(val, editBl) { // 电子围栏--打开/关闭  val,editBl:是否画圆/是否是编辑状态
      if (val) { // 打开
        this.drawCircle(this.lng, this.lat, this.radius)// 电子围栏--画圆
        if (!editBl) this.editorFence() // 新建围栏时，画圈的同时打开编辑
      } else {
        this.deleteFence()
      }
    },
    queryList() {
      findDeviceInfo({ 'mcuId': this.$route.query.mcuId }).then(res => {
        // console.log(response)
        this.basicinfo = res.resultModel
        if (this.basicinfo.batteryCapacity) this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? (this.basicinfo.batteryCapacity / 100) : (this.basicinfo.batteryCapacity)
        else { this.basicinfo.batteryCapacity = '--' }
        if (this.basicinfo.batteryVoltage) this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? (this.basicinfo.batteryVoltage / 100) : (this.basicinfo.batteryVoltage)
        else { this.basicinfo.batteryVoltage = '--' }
      })
    },
    goToDetailgPage() { // 去详情页
      var routeData = this.$router.resolve({
        path: '/allDevices/allDeviceDetail',
        query: {
          mcuId: this.mcuId,
          deviceType: this.basicinfo.deviceType,
          sn: this.basicinfo.deviceSn
          // id: this.basicinfo.id
        }
      })
      window.open(routeData.href, '_self')
    },
    queryFence() { // 电子围栏--初始化
      this.editFenceBl = false
      this.loading = true
      getGnssGeofenceByMcuId({ mcuId: this.mcuId }).then(res => {
        this.loading = false
        if (res.resultCode == 1001) {
          if (res.resultModel) { // 有围栏信息
            var lntLat = res.resultModel.pointDatas[0] || {}
            if (lntLat.gpsLong || lntLat.gpsLong == 0) this.lng = this.editLng = lntLat.gpsLong
            if (lntLat.gpsLat || lntLat.gpsLat == 0) this.lat = this.editLat = lntLat.gpsLat
            this.radius = this.editRadius = res.resultModel.radius
            this.dataTime = [res.resultModel.startTime, res.resultModel.endTime]
            this.textarea = res.resultModel.remark
            this.isOpenFence = true
            this.setPosition(this.zoom + 5)
            this.changeOpenFence(true, 'init')
          } else {
            this.isOpenFence = false
            this.radius = this.editRadius = 2000
          }
        }
      })
    },
    drawCircle(lng, lat, radius) { // 电子围栏--画圆
      if (!this.dataTime.length) {
        var t = new Date().setHours(0, 0, 0, 0)
        this.dataTime = [t, t + 30 * 24 * 60 * 60 * 1000 - 1000]
      }
      var color = this.dataTime[1] < Date.now() ? '#999' : '#07d15d'
      if (this.currentMap == 'tianMap') {
        this.map.clearOverLays()
        console.log('drawCircle:this.lng', this.lng)
        this.circle = new T.Circle(tianMapLngLat(lng, lat), radius, { color: color, weight: 3, opacity: 0.5, fillColor: '#FFFFFF', fillOpacity: 0.5 })
        this.map.addOverLay(this.circle)
        this.setPosition(this.zoom + 5)
        this.map.centerAndZoom(tianMapLngLat(this.editLng, this.editLat))
      } else {
        if (this.circle) this.circle.setMap(null)
        this.circle = new google.maps.Circle({
          center: { lat: this.lat, lng: this.lng }, // 圆心位置
          radius: this.radius, // 半径
          strokeOpacity: 0.5, // 线透明度
          strokeWeight: 3, // 线粗细度
          fillColor: '#FFFFFF',
          strokeColor: color,
          fillOpacity: 0.5, // 填充透明度
          map: this.map
        })
        this.map.setZoom(10)
        this.map.setCenter(new google.maps.LatLng(this.lat, this.lng))
      }
    },
    deleteFence() { // 电子围栏--删除
      this.$confirm(this.$t('location.delete2'), '', {
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        updateGnssGeofenceStatus({
          mcuId: this.mcuId,
          status: 2
        }).then(res => {
          if (res.resultCode == 1001) {
            this.map.clearOverLays()
            this.setPosition(this.zoom + 5)
            this.radius = this.editRadius = 2000
            this.isOpenFence = this.editFenceBl = false
            this.dataTime = this.textarea = ''
            this.$message({
              type: 'success',
              message: this.$t('location.agdeleted')
            })
          }
        })
      }).catch(() => {
        this.isOpenFence = true
      })
    },
    editorFence() { // 电子围栏--编辑
      const that = this
      this.editFenceBl = true
      this.editLng = this.lng
      this.editLat = this.lat
      this.editRadius = this.radius
      if (this.currentMap == 'tianMap') {
        this.circle.enableEdit()
        this.map.addEventListener('mousemove', function() {
          that.editRadius = that.circle.getRadius().toFixed(0)
          that.editLng = wgsToGcj(that.circle.getCenter().lng, that.circle.getCenter().lat)[0]
          that.editLat = wgsToGcj(that.circle.getCenter().lng, that.circle.getCenter().lat)[1]
        })
      } else {
        this.circle.set('draggable', true)
        this.circle.set('editable', true)
        this.circle.addListener('mouseover', function(e) { // '在围栏里面，按住鼠标左键可移动围栏位置'
          if (!that.editFenceBl) return
        })
        this.circle.addListener('radius_changed', function() { // 改变半径后触发
          if (!that.editFenceBl) return
          that.editRadius = that.circle.getRadius().toFixed(0)
        })
        this.circle.addListener('drag', function(e) { // 移动时触发(点到中心点时,移动不触发)
          if (!that.editFenceBl) return
          that.editLng = that.circle.getCenter().lng()
          that.editLat = that.circle.getCenter().lat()
        })
        this.circle.addListener('center_changed', function() { // 移动时不触发，点到中心点移动后触发
          if (!that.editFenceBl) return
          that.editLng = that.circle.getCenter().lng()
          that.editLat = that.circle.getCenter().lat()
        })
      }
    },
    submit() { // 电子围栏--保存
      if (!this.dataTime) {
        this.$message.error(this.$t('location.pleaseSelectDate'))
        return
      }
      addGnssGeofence({
        endTime: this.dataTime[1],
        id: 0,
        mcuId: this.mcuId,
        points: [{ gpsLat: this.editLat, gpsLong: this.editLng }],
        radius: this.editRadius,
        remark: this.textarea,
        startTime: this.dataTime[0],
        status: 1
      }).then(res => {
        if (res.resultCode == 1001) {
          this.lng = this.editLng
          this.lat = this.editLat
          this.radius = Number(this.editRadius)
          if (this.currentMap == 'tianMap') {
            this.map.centerAndZoom(tianMapLngLat(this.editLng, this.editLat))
          } else {
            this.map.setCenter(new google.maps.LatLng(this.editLat, this.editLng))
            this.circle.set('draggable', false)
            this.circle.set('editable', false)
          }
          this.drawCircle(this.lng, this.lat, this.radius)// 改变有效期可能导致围栏颜色改变，故重新画圈

          this.$message({
            message: this.$t('location.updated'),
            type: 'success'
          })
          this.editFenceBl = false
          if (this.currentMap == 'tianMap') this.circle.disableEdit()
        }
      })
    },
    listWarningPushMsg() { // 获取警告信息
      var param = {
        // mcuId: '060808091002ff0affff0082',
        mcuId: this.$route.query.mcuId,
        msgType: 6
      }
      listWarningPushMsg(param).then(res => {
        this.warningTableData = res.resultModel || []
        this.warningTableData.forEach(v => {
          v.createTimeZh = getDateAndHour(v.createTime, 'noSecond')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.electricFence{
  height: 100%;
  position: relative;
}
.map_box {
  position: relative;
  height:calc(100vh - 220px);
  width:100%;
  margin: 20px 0 0 0px;
  background:#fff;
}
#location{
  width:calc(100% - 10px);
  height:calc(100% - 10px);
  position:absolute;
  top: 5px;
  left: 5px;
}
.amap {
  border-radius: 10px;
}
.contentInfoBox {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 400;
  min-width: 350px;
  background: #fff;
  border-radius: 5px;
  .geofencingSwitch{
    padding:10px 20px;
    border:1px solid #ccc;
  }
  .location_form_box {
    width: 400px;
    border-radius: 10px;
    padding:10px 20px;
    .item_box {
      margin-bottom: 5px;
    }
    .geofencSetP{
      margin-bottom: 5px;
      color:#999;
      align-items: center;
    }
    .itemBack{
      background: #F5F5F5;
      padding:5px 10px;
      border-radius: 5px;
    }
    .el-date-editor,.el-textarea{
      width: 260px;
    }
    .tips{
      color:#ccc;
      margin:10px 0;
    }
  }
  .deviceTheme{
    font-weight: bold;
    border: 1px solid #1890ff;
    color: #1890ff;
    border-radius: 5px;
    padding: 5px 10px;
  }
  .warnWarp{
    padding:0 0 10px;
    .warnP{
      padding:10px 20px 5px;
      border-top:1px solid #ccc;
      margin-bottom: 0;
    }
    .warnItem{
      padding:0 20px;
      margin:10px 0;
    }
    .item_box{
      margin: 10px 0;
      display: flex;
      align-items: flex-start;
      img{
        margin-right: 10px;
      }
    }
    .status{
      padding:2px 6px;
      border-radius: 5px;
      margin-right: 20px;
    }
    .info{
      color: #909399;
      background: #f4f4f5;
      border-color: #d3d4d6;
    }
    .danger{
      color: #f56c6c;
      background: #fef0f0;
      border-color: #fbc4c4;
    }
  }
  .warnMsgImg{
    width: 20px;
  }
  .warnBox{
    max-height: 300px;
    overflow-y: auto;
  }
}

</style>
